import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuestion = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null); // Close the currently open question
    } else {
      setActiveIndex(index); // Open the clicked question
    }
  };

  const faqData = [
    {
      question: "¿Cómo participo en un sorteo?",
      answer: "Para participar, simplemente debes registrarte en la plataforma, elegir el sorteo en el que deseas participar y comprar los números correspondientes. Cada número tiene un valor y, al comprarlos, estarás participando en el sorteo."
    },
    {
      question: "¿Cómo me registro en la plataforma?",
      answer: "El registro en MEGALOTO es muy fácil. Solo necesitas ingresar tu nombre, correo electrónico, número de teléfono, y aceptar las políticas de privacidad. Una vez registrado, podrás comenzar a participar en los sorteos."
    },
    {
      question: "¿Qué es MEGALOTO?",
      answer: "MEGALOTO es una plataforma de sorteos en línea donde puedes participar por premios en efectivo, productos y más. Cada sorteo tiene un costo por número, y el premio aumenta conforme más personas participan."
    },
    {
      question: "¿Puedo invitar a otros usuarios?",
      answer: "Sí, puedes invitar a otras personas para que participen en los sorteos a través de tu enlace personalizado. Por cada compra que hagan tus referidos, recibirás un porcentaje de las ganancias."
    },
    {
      question: "¿Cómo se realiza el pago de los números?",
      answer: "El pago de los números se realiza a través de Nequi o Daviplata. Una vez confirmada tu compra, el saldo se actualizará en tu cuenta, y estarás listo para participar en el sorteo."
    },
    {
      question: "¿Cómo puedo ver los resultados de los sorteos?",
      answer: "Los resultados de los sorteos se publican directamente en la plataforma, y te notificaremos si has ganado algún premio."
    }
  ];

  return (
    <div className="faq">
      <h2 className="faq-title">Preguntas Frecuentes</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <div 
              className="faq-question" 
              onClick={() => toggleQuestion(index)}
            >
              <h3>{item.question}</h3>
              <span>{activeIndex === index ? '-' : '+'}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
